import engineTasksModel from 'modules/engine-tasks/model';

const wizardConfig = {
  model: engineTasksModel,
  steps: [
    {
      path: 'select-source',
      label: 'Select Source',
      fields: [engineTasksModel.fields.selectedFile]
    },
    {
      path: 'select-options',
      label: 'Select Options',
      fields: [
        engineTasksModel.fields.buildId,
        engineTasksModel.fields.parameters,
        engineTasksModel.fields.libraryIds
      ]
    }
  ]
};

export default wizardConfig;



// WEBPACK FOOTER //
// ./src/client/plugins/engines/pages/engine-tasks/pages/create-test-wizard/wizard-config.js